import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { useStats } from 'react-instantsearch';

import {
  SearchFacetRefinementCheckboxes,
  SearchFacets as DefaultSearchFacets,
} from '@uncinc/react-searchkit';

import { useWindowDimensions, Button } from '@uncinc/uncinc-react-kitchen-sink';
import { TYPE_NAME_MAPPING } from '../config';
import { SCREEN_WIDE } from '../../../config/constants';

import './style.scss';

const SearchFacets = () => {
  const { width } = useWindowDimensions();
  const [mobileSearchFacetsDisplayed, setMobileSearchFacetsDisplayed] = useState(false);
  const [showTopGradientBar, setShowTopGradientBar] = useState(false);

  const mobileViewIsActive = width <= SCREEN_WIDE;
  const { nbHits } = useStats();

  const transformTypeItems = useCallback((items) => items.map((item) => ({
    ...item,
    label: TYPE_NAME_MAPPING[item.value],
  })), []);

  const classes = classNames('SearchFacets', {
    'mobile-facets-active': mobileViewIsActive && mobileSearchFacetsDisplayed,
  });

  return (
    <div className={classes}>
      <DefaultSearchFacets>
        {/* Facet heading */}
        <div className="facets-heading">
          <h3>Filter resultaten</h3>
        </div>

        {/* Type Facet */}
        <div className="SearchContent__facet_type">
          <div className="facets-label">Toon alleen</div>
          <SearchFacetRefinementCheckboxes attribute="type" sortBy={['name:asc']} transformItems={transformTypeItems} />
        </div>

        {(mobileViewIsActive && !mobileSearchFacetsDisplayed) && (
          <div className="SearchContent__facet__more">
            <Button className="Button--inverted Button--block" onClick={() => setMobileSearchFacetsDisplayed(true)}>
              Meer filters
            </Button>
          </div>
        )}

        <div className="SearchFacets__more">
          <div className="SearchFacets__more__heading">
            <div className="SearchFacets__more__heading__title">
              <h3>Filter resultaten</h3>
            </div>
            <div className="SearchFacets__more__heading__close" onClick={() => setMobileSearchFacetsDisplayed(false)}>
              <i className="icon icon-cross" />
            </div>
          </div>
          <div className="SearchFacets__filters"
            onScroll={(e) => setShowTopGradientBar(e.target.scrollTop > 30)}
          >
            {showTopGradientBar && (
              <div className="gradient top" />
            )}

            {/* Theme Facet */}
            <div className="SearchContent__facet_theme">
              <div className="facets-label">Thema</div>
              <SearchFacetRefinementCheckboxes attribute="theme_name" sortBy={['name:asc']} />
            </div>

            {/* Pillar Facet */}
            <div className="SearchContent__facet_pillar">
              <div className="facets-label">Pijlers</div>
              <SearchFacetRefinementCheckboxes attribute="pillar_name" sortBy={['name:asc']} />
            </div>

            <div className="gradient bottom" />
          </div>
          <div className="SearchFacets__more__footer">
            <div className="SearchFacets__more__footer__action">
              <Button className="Button--primary Button--block" onClick={() => setMobileSearchFacetsDisplayed(false)}>
                Toon {nbHits} resultaten
              </Button>
            </div>
          </div>
        </div>

      </DefaultSearchFacets>
    </div>
  );
};

export default SearchFacets;
